import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ChatBubbleCheckIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M7.66667 12h-4L1 14.6667V2.66671c0-.73334.6-1.33334 1.33333-1.33334H13c.7333 0 1.3333.6 1.3333 1.33334v4.66666H13V2.66671H2.33333v7.99999h5.33334V12ZM15 9.56004l-.94-.94-2.8267 2.82666L9.82 10.0334l-.94.94 2.3467 2.36L15 9.56004Z" />
  </Icon>
);

export default memo(ChatBubbleCheckIcon);
